import Denise from "../../../assets/About/jpeg-optimizer_Denise.jpeg"; 
import Carla from "../../../assets/About/jpeg-optimizer_Carla.jpeg"
import Sydney from "../../../assets/About/jpeg-optimizer_Sydney.jpeg"
import Martha from "../../../assets/About/jpeg-optimizer_Martha.jpeg"
import Adam from "../../../assets/About/jpeg-optimizer_Adam.jpeg"
import Paragraph from "./Paragraph.jsx"

const DeniseParagraph = (
  <div>
    <p>
    <b>Denise Westby</b> grew up knowing that flute was her "thing" from the age of 11. A member of the earliest Metropolitan Youth Symphony as well as the Portland Youth Philharmonic, she received her initial training from John May of the Oregon Symphony and then went on to attend the University of Oregon School of Music, where she earned her performance degree. Denise has been a performer in Master Classes of Jean-Pierre Rampal, John Solum, and Mindy Kaufman, among others.
    </p>
    <p>
    Currently, Ms. Westby teaches The Business of Music course at Portland State University and is an adjunct flute instructor at Mt. Hood Community College. She served as the adjunct flute instructor at Linfield College for nearly 20 years and has an active home studio in Tigard. Denise has been a busy freelance performer in diverse groups of many genres, including Principal Flute in Sinfonia Concertante Orchestra, the Moody Blues orchestra, and "5tet" WW Quintet among others.
    </p>
    <p>
    An avid believer in music education, she helped found the non-profit, Music Education Assistance Project, Inc. while an officer of the American Federation of Musicians, Local #99. She is the founder and administrator of Flute Alliance and enjoys coaching both large and small ensembles of kids through adults.
    </p>
    <p>
    Contact her: denise.westby5@gmail.com or flutealliance@gmail.com
    </p>
  </div>
)

const CarlaParagraph = (
  <div>
    <p>
      <b>Carla Wilson</b> held the Third Flute/Piccolo position with the Oregon Symphony from 1973-2012.  Her teachers included John May, Jean-Pierre Rampal, and Walfrid Kujala.  Her passion is for music education in the schools and has developed specialized programs to assist classroom teachers to encourage an appreciation for music in children.  As a member of Flute Alliance she is able to combine her passion with her expertise in piccolo and flute performance.
    </p>
    <p>
      Carla is a strong advocate for music in the schools. As a musician with the Oregon Symphony she served on the Education Committee and participated in the educational activities sponsored by the orchestra both in town and on tour. She is active in developing programs that introduce classical music to students in the classroom. Currently Carla is working with classroom teachers developing arts integrated curriculum units with a music focus.
    </p>
    <p>
      She currently holds the position of adjunct professor of flute at University of Portland and has been a flute instructor at Lewis and Clark College, Reed College and Linfield College. She maintains a private flute studio in Northeast Portland.
    </p>
  </div>
)

const SydneyParagraph = (
  <div>
    <p>
      <b>Dr. Sydney Carlson</b> joined the faculty of Portland State University in 2008. Currently a member of the Portland Opera Orchestra, she has performed with the Oregon Symphony, Portland Ballet Orchestra and Portland Chamber Orchestra. She is a former member of the Houston Grand Opera Orchestra. While in Houston she performed frequently with the Houston Symphony, Houston Ballet Orchestra, and contemporary ensemble Musiqa.
    </p>
    <p>
      She has served on the faculties, of the Texas Music Festival and the American Festival of the Arts as a chamber music coach, flute teacher and recitalist.  International appearances include concerts in Mexico City, Xalapa, Veracruz, and Merida.  She has performed with the American Sinfonietta as principal flute on a tour of Europe and at the Bellingham Festival in WA.  In 2009 she made her recital debut in China at the Xinghai Conservatory of Music in Guangzhou China.
    </p>
    <p>
      Sydney holds degrees form the Eastman School of Music, East Carolina University and the University of Houston. She was <i>privileged</i> to study with Byron Hester, Bonita Boyd, and David Shostac. Additionally she has performed in the master classes of Julius Baker, Jean-Pierre Rampal, Robert Aitken, Samuel Baron and James Walker. She has recorded on the Mark, Delos, Albany, Guild, CIEM, and Urtext Digital labels.
    </p>
  </div>
) 

const MarthaParagraph = (
  <div>
    <p>
      <b>Martha Long, Principal Flute, Oregon Symphony Orchestra. Powell Flutes Performing Artist.</b>
    </p>
    <p>
      <b>Martha Conwell Long</b> joined the Oregon Symphony as principal flute at the beginning of the 2016-2017 season. Before moving to Portland, Martha was principal flute with the San Antonio Symphony for four seasons and appeared several times as a soloist with that orchestra, performing works by Bach, Mozart, and Telemann. Martha received a B.M. from the Colburn School in Los Angeles, where she studied with Jim Walker. She continued her studies at the New England Conservatory in Boston, where she completed a Graduate Diploma as a student of Elizabeth Rowe. While in school, Martha furthered her orchestral studies during summers at Music Academy of the West and Tanglewood Music Center. As an undergraduate at Colburn, Martha was named principal flute of the Fort Collins Symphony Orchestra in Colorado, a position she held for three years before she moved to San Antonio. She has also guested with the Colorado Symphony and served as principal flute of the Oregon Bach Festival.
    </p>
    <p>
      Ms. Long is also a two-time winner in the NFA’s Masterclass Performer Competition and a past winner of the NFA’s Baroque Flute Masterclass Competition. During the summer of 2015, Ms. Long was a prizewinner at the NFA’s Young Artist Competition. For more information, visit <a href="http://www.marthaclong.com/" target="_blank" rel="noreferrer">www.marthaclong.com</a>.
    </p>
  </div>
)

const AdamParagraph = (
  <div>
    <p>
     A devoted humanitarian and firm supporter of arts education, <b>Adam Eccleston</b> has worked extensively with many social change organizations such as, BRAVO Youth Orchestras, where he is the Program Director.  BRAVO is an El Sistema inspired music program based in Portland, Oregon that serves over 600 students. He is a faculty member with the Global Leaders Program that empowers arts changemakers to grow organizations that impact communities. Adam serves on the board of the Greater Portland Flute Society and is currently on the committee of the Umoja Flute Institute, which celebrate flutists of African descent and their contributions to music. 
    </p>
    <p>
     As a performer, Adam has appeared with orchestras such as the Oregon Symphony. At 19 years old, he made his solo debut in New York performing Borne Carmen Fantasy for Flute and Orchestra.  Adam has been awarded top prizes in competitions, one of which is the New York Flute Club Competition and most recently, First Prize in the Golden Classical Music Award International Competition for which he was featured at Carnegie Hall. Currently, he is the Artist in Residence for All Classical Portland Radio Station and sits as Chair of the newly Recording Inclusivity Initiative, which brings to light music of underrepresented composers. As a firm supporter of new music, he has premiered works by Robert Beaser, Anthony Green and made the Pacific Northwest premiere of works by Valerie Coleman and Julio Racine. 
    </p>
    <p>Mr. Eccleston studied with Paula Robison, Tara Helen O’Connor, Eric Lamb and Thaddeus Watson, retired piccolo player of the Frankfurt Radio Symphony Orchestra at the Frankfurt Hochschule für Musik und Darstellende Kunst. He currently holds two master degrees and enjoys baking and watching the Real Housewives of Atlanta.</p>
    <p>Mr. Eccleston plays on a 14K White Gold Powell flute.</p>
  </div>
)

export const instructorData = [
  {
    paragraphs: (
      <Paragraph 
        image={Denise} 
        name={"Denise Westby"}
        paragraphs={DeniseParagraph} 
      />
    )
  },
  {
    paragraphs: (
      <Paragraph 
        image={Carla} 
        name={"Carla Wilson"}
        paragraphs={CarlaParagraph} 
      />
    )
  },
  {
    paragraphs: (
      <Paragraph 
        image={Sydney} 
        name={"Dr. Sydney Carlson"}
        paragraphs={SydneyParagraph} 
      />
    )
  },
  {
    paragraphs: (
      <Paragraph 
        image={Martha} 
        name={"Martha Long"}
        paragraphs={MarthaParagraph} 
      />
    )
  },
  {
    paragraphs: (
      <Paragraph 
        image={Adam} 
        name={"Adam Eccleston"}
        paragraphs={AdamParagraph} 
      />
    )
  }

]
